/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var XCircleIcon16Regular = forwardRef('XCircleIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6.409 5.348a.75.75 0 0 0-1.06 1.061L6.938 8 5.35 9.591a.75.75 0 1 0 1.06 1.06L8 9.062l1.591 1.59a.75.75 0 1 0 1.06-1.06L9.062 8l1.59-1.591a.75.75 0 0 0-1.06-1.06L8 6.938 6.409 5.35Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1ZM2.5 8a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Z" })));
});
